import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { paths } from '@AppRoutes/constants';

import PersonalizationUserDropdownContainer from '@Containers/Header/UserDropdown/PersonalizationUserDropdownContainer';
import { linkClassNamesObj } from '@Utils/router-state';

function AnonShibbolethLogin({ stateCurrentName, userHasRegistration, getRouterHref, userLinkHandler, onSignOutClick, openLogoutDialog }) {
  return userHasRegistration ? (
    <li className="u-els-padding-left-1o2 rx-menu-item--user">
      <PersonalizationUserDropdownContainer
        id="personalization-user-dropdown"
        userLinkText="Activate Personalization"
        userLinkClassName={classnames('dropdown-menu--item', linkClassNamesObj(stateCurrentName, paths.PRIVATE_REGISTER))}
        userLinkHref={getRouterHref(paths.PRIVATE_REGISTER)}
        userLinkHandler={userLinkHandler}
        openLogoutDialog={openLogoutDialog}
      />
    </li>
  ) : (
    <li className="u-els-padding-left-1o2">
      <a
        data-e2e="anon-shibboleth-sign-out"
        className="u-els-color-n9 u-els-line-height-default u-els-padding-bottom-1o4"
        href="null"
        aria-label="Sign out"
        onClick={(e) => {
          e.preventDefault();
          onSignOutClick();
        }}>
        <span className="rx-menu-item--label">Sign out</span>
      </a>
    </li>
  );
}

AnonShibbolethLogin.propTypes = {
  stateCurrentName: PropTypes.string.isRequired,
  userHasRegistration: PropTypes.bool,
  getRouterHref: PropTypes.func.isRequired,
  userLinkHandler: PropTypes.func.isRequired,
  onSignOutClick: PropTypes.func.isRequired,
  openLogoutDialog: PropTypes.func.isRequired,
};

export default AnonShibbolethLogin;
